import { selector } from "recoil";
import { businessProfileState } from "../../../atoms/business/businessProfile";

export const nameSelector = selector({
    key: "nameSelector",
    get: ({ get }) => get(businessProfileState).name,
    set: ({ set }, newValue) => {
      set(businessProfileState, (prevState: any) => ({ ...prevState, name: newValue }))
    }
})